/**
 * @aiPurpose singleton portal target for the {@link Menu} primitive's
 *   panel; mounted once by `RootLayout` next to `<ModalHost />`.
 * @aiInvariant renders exactly one `<div id="popover-host" />` per app
 *   instance; consumers MUST mount it before any open `<Menu>` can
 *   measure its panel size.
 */
export function PopoverHost() {
  return <div id="popover-host" />;
}
